import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import ResetPassConfirmation from './ResetPassSuccess';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(ResetPassConfirmation);

export default connect(
  mapStateToProps,
)(Styled);
